"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowForwardCircle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowForwardCircle = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm3.42-12.432l-3.6-3.6a.6.6 0 00-1.02.432v7.2a.6.6 0 001.02.42l3.6-3.6a.612.612 0 000-.852z", clipRule: "evenodd" })); };
exports.ArrowForwardCircle = ArrowForwardCircle;
//# sourceMappingURL=arrow-forward-circle.js.map